/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { PrimaryButton, DefaultButton } from '@bingads-webui-react/fabric-control';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import {
  globalErrorMsg, bidStrategyOptionKeys,
  getCampaignTargetsCriterions, getAdGroupTargetsCriterions, getCampaignData, getAdGroupData, handleApiErrors, clearSubViewApiErrors, scrollToErrors,
  invalidateCache, subscribeUrlOptions, subscribeSiteExclusion, mergeAdGroupStateWithErrors, showWarning, createDefaultHotelGroup, audienceAdsOptionKeys,
  send, sendErrors,
} from '@bingads-webui-campaign/hotel-common-upsert';
import { Errors, modelToViewModelDayTimeTargets, locationTargetsOptionKeys } from '@bingads-webui-campaign-react/wizard-shared-components';
import {
  parseLocationTargets
} from '@bingads-webui-campaign/hotel-common-targets';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import exclusionRepository from '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository';
import { AdgroupBasic, defaultAdgroupBasicData, AdvancedSettings, AdgroupTargets, fieldsToCheck, Title } from './components';
import { convertAdgroupStateToAdgroupJSONSchemaData, validateAdGroupState, generateDataToInvalidState } from './util';
import { renderAdGroupTargets, updateAllTargets } from './get-targets-criterion';

export const scenarios = {
  settings: 'settings',
  creation: 'creation',
};

export const HotelAdGroupBase = class HotelAdGroupBase extends React.Component {
  constructor(props) {
    super(props);
    this.isCreation = this.props.scenario === scenarios.creation;
    this.initializeTheInstrumentation();

    this.state = {
      adgroup: {
        ...defaultAdgroupBasicData,
      },
      campaign: {
      },
      initTargets: {},
      isLoading: true,
      isDataFetched: false,
      errMsg: {},
      adgroupApiErrors: [],
      targetsApiErrors: {},
      advancedSettinsApiErrors: {},
    };
    this.subViews = {};
    this.adScheduleView = undefined;
    this.adDistributionView = undefined;
    this.siteExclusionView = undefined;
    this.urlOptionsView = undefined;
    this.defaultHotelGroupCreated = props.scenario === scenarios.settings;
    this.setAdScheduleView = (view) => {
      this.adScheduleView = view;
      this.adScheduleView.koModel.hasErrors.subscribe((x) => {
        if (x) {
          this.patchErrMsg('adSchedule', globalErrorMsg);
          return;
        }
        this.patchErrMsg('adSchedule', '');
      });
    };
    this.setAdDistributionView = (view) => { this.adDistributionView = view; };
    this.getAdDistributionView = () => this.adDistributionView;
    this.setSiteExclusionView = (view) => { this.siteExclusionView = view; subscribeSiteExclusion(this); };
    this.setUrlOptionsView = (view) => {
      this.urlOptionsView = view;
      this.subViews.urlOptionsView = view;
      subscribeUrlOptions(this, globalErrorMsg);
    };
    const adgroupEDM = edmCampaign.types.resolve('Model.AdGroup');
    this.adgroupResource = new adgroupEDM.ResourceIdentifier();
  }

  // eslint-disable-next-line react/sort-comp
  handleCreateOrUpdateSuccess = (response, resolve) => {
    const {
      scope,
      siteMap,
    } = this.props;
    if (this.isCreation) {
      const adGroupId = this.getCreatedAdGroupId(response);
      send(this.activity, 'adgroup_creation_succeeded', { adGroupId });
      this.createDefaultHotelGroupAfterAdGroupCreation(response, () => {
        send(this.activity, 'all_succeeded');
        this.durationActivity.stopSignal('completed');
        scope.save(getRoutePathById(siteMap, 'adgroups'));
      }).finally(() => resolve(true));
    } else {
      send(this.activity, 'adgroup_update_succeeded');
      // we backfill advanced settings models here, so we have correct model if the saveExtensions call fails.
      this.updateResponseData({ entity: response }, resolve);

      if (this.isExclusionsUpdated()) {
        this.saveExtensions().then(() => {
          send(this.activity, 'all_succeeded');
          this.durationActivity.stopSignal('completed');
          scope.remove('adGroupId');
          scope.save('/campaign/vnext/adgroups');
        });
      } else {
        send(this.activity, 'all_succeeded');
        this.durationActivity.stopSignal('completed');
        scope.remove('adGroupId');
        scope.save('/campaign/vnext/adgroups');
      }
    }
  };

  getCreatedAdGroupId = (response) => {
    let entity = response;
    if (response && response.entity) {
      // eslint-disable-next-line prefer-destructuring
      entity = response.entity;
    }
    return entity.Id;
  };

  scrollAndShowWarning() {
    this.removeWarningInterval = showWarning('adgroup', this.props.i18n, this.removeWarningInterval);
    scrollToErrors('adgroup');
  }

  createDefaultHotelGroupAfterAdGroupCreation = (response, callback) => {
    if (!this.defaultHotelGroupCreated) {
      const adGroupId = this.getCreatedAdGroupId(response);

      if (adGroupId) {
        const {
          cid,
          aid,
          campaignId,
        } = this.props.scope.values;
        let bid = 0.05;
        let type = 'FixedBid';
        const {
          bidStrategy,
        } = this.state.campaign;
        const {
          baseBid,
        } = this.state.adgroup;
        switch (bidStrategy.option) {
          case bidStrategyOptionKeys.ManualCpc:
            bid = baseBid.searchBid;
            type = 'FixedBid';
            break;
          case bidStrategyOptionKeys.PercentCpc:
            bid = baseBid.percentCpcBid;
            type = 'RateBid';
            break;
          case bidStrategyOptionKeys.Commission:
            bid = baseBid.commissionRate;
            if (bid == null || bid.length === 0) {
              bid = bidStrategy.Commission;
            }
            type = 'RateBid';
            break;
          default:
            bid = 0.05;
            type = 'FixedBid';
            break;
        }
        return createDefaultHotelGroup(cid, aid, campaignId, adGroupId, type, bid).then(() => {
          send(this.activity, 'hotel_group_creation_succeeded');
          this.defaultHotelGroupCreated = true;
          if (callback) {
            callback();
          }
        }).catch((res) => {
          send(this.activity, 'hotel_group_creation_failed');
          sendErrors(this.activity, 'hotel_group_creation_error', res);
          // TODO: should not get here.
          let errors;
          if (res.errors) {
            errors = i18nErrors.getODataErrors(res.errors);
          }
          if (errors && errors.length) {
            this.setState(prevState => ({
              adgroupApiErrors: prevState.adgroupApiErrors.concat(errors),
            }));
            this.scrollAndShowWarning();
          }
        });
      }
    }
    return new Promise((resolve) => {
      if (callback) {
        callback();
      }
      resolve(true);
    });
  };

  handleCreateOrUpdateError = (response, resolve) => {
    if (this.isCreation) {
      send(this.activity, 'adgroup_creation_failed');
      sendErrors(this.activity, 'adgroup_creation_error', response);
    } else {
      send(this.activity, 'adgroup_update_failed');
      sendErrors(this.activity, 'adgroup_update_error', response);
    }
    const allApiErrors = handleApiErrors(response, this.props.i18n, this.subViews, 'adgroup');
    this.setState(prevState => ({
      adgroup: {
        ...mergeAdGroupStateWithErrors(prevState.adgroup, allApiErrors),
      },
      adgroupApiErrors: allApiErrors.entityApiErrors.General || [],
      targetsApiErrors: allApiErrors.targetsApiErrors,
      advancedSettinsApiErrors: allApiErrors.advancedSettinsApiErrors,
    }));
    this.updateResponseData(response, resolve); // we backfill models here
  };

  createOrUpdateAdgroup = (data) => {
    const createOrUpdateCall = this.isCreation ? this.adgroupResource.bulkCreate.bind(this.adgroupResource) : this.adgroupResource.bulkUpdate.bind(this.adgroupResource);
    return new Promise(resolve => createOrUpdateCall(data)
      .then(response => this.handleCreateOrUpdateSuccess(response, resolve))
      .catch(response => this.handleCreateOrUpdateError(response, resolve)));
  };

  getCurrentCampaign() {
    const {
      currentCampaign,
    } = this.props;
    return currentCampaign;
  }

  validate = () => {
    const {
      serverContext,
    } = this.props;
    const campaignBidStrategyType = this.state.campaign && this.state.campaign.bidStrategy && this.state.campaign.bidStrategy.option;
    let validationData = validateAdGroupState(this.state.adgroup, serverContext, campaignBidStrategyType, this.patchAdgroup, this.patchErrMsg);
    validationData = Object.assign(
      validationData,
      { urlOptions: this.urlOptionsView ? this.urlOptionsView.validate() : true },
      { adSchedule: this.adScheduleView ? this.adScheduleView.validate() : true }
    );
    const isValid = fieldsToCheck.every(x => validationData[x] === true);

    if (isValid !== true) {
      this.setState(prevState => ({
        adgroup: {
          ...generateDataToInvalidState(validationData, prevState.adgroup),
        },
      }));
    }
    return isValid;
  };

  fetchCampaignDayTimeCriterions(cid, aid, campaignId) {
    const getCampaignDayTimeCriterionsPromise = getCampaignTargetsCriterions({
      type: "isof(Criterion,'Model.DayTimeCriterion')", cid, aid, campaignId,
    });
    return Promise.all([getCampaignDayTimeCriterionsPromise]).then(([rawCampaignDayTimeRanges]) => {
      const campaignDayTimeRanges = modelToViewModelDayTimeTargets(rawCampaignDayTimeRanges);
      this.setState(prevState => ({
        campaign: { ...prevState.campaign, dayTimeRanges: campaignDayTimeRanges },
      }));
    });
  }

  fetchCampaignLocationCriterions(cid, aid, campaignId) {
    const getCampaignLocationCriterionsPromise = getCampaignTargetsCriterions({
      type: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.LocationIntentCriterion')", cid, aid, campaignId,
    });
    return Promise.all([getCampaignLocationCriterionsPromise]).then(([rawCampaignLocations]) => {
      const {
        locations: campaignLocations,
      } = parseLocationTargets(rawCampaignLocations, 'campaign', campaignId);
      this.setState(prevState => ({
        adgroup: {
          ...prevState.adgroup,
          location: {
            ...prevState.adgroup.location,
            parentLevelSettings: {
              initLocations: campaignLocations,
              currentLocations: campaignLocations,
            },
            bidMode: true,
          },
        },
      }));
    });
  }

  fetchDayTimeCriterions(cid, aid, campaignId, adGroupId) {
    const getCampaignDayTimeCriterionsPromise = getCampaignTargetsCriterions({
      type: "isof(Criterion,'Model.DayTimeCriterion')", cid, aid, campaignId,
    });
    const getAdGroupDayTimeCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.DayTimeCriterion')", cid, aid, campaignId, adGroupId,
    });
    return Promise.all([getCampaignDayTimeCriterionsPromise, getAdGroupDayTimeCriterionsPromise]).then(([rawCampaignDayTimeRanges, rawAdGroupDayTimeRanges]) => {
      const campaignDayTimeRanges = modelToViewModelDayTimeTargets(rawCampaignDayTimeRanges);
      const adGroupDayTimeRanges = modelToViewModelDayTimeTargets(rawAdGroupDayTimeRanges);
      this.setState(prevState => ({
        campaign: { ...prevState.campaign, dayTimeRanges: campaignDayTimeRanges },
        adgroup: { ...prevState.adgroup, dayTimeRanges: adGroupDayTimeRanges, adSchedule: { useParentLevel: _.isEmpty(adGroupDayTimeRanges) } },
      }));
    });
  }

  syncAdGroupLocationCriterions(cid, aid, campaignId, adGroupId) {
    invalidateCache('Model.AdGroupCriterion');
    const getAdGroupLocationCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion')", cid, aid, campaignId, adGroupId,
    });
    return getAdGroupLocationCriterionsPromise.then((rawLocations) => {
      const {
        locations,
      } = parseLocationTargets(rawLocations, 'campaign', campaignId);
      this.setState(prevState => ({
        adgroup: {
          ...prevState.adgroup,
          location: {
            ...prevState.adgroup.location,
            currentLevelSettings: {
              ...prevState.adgroup.location.currentLevelSettings,
              initLocations: locations,
            },
          },
        },
      }));
    });
  }

  fetchLocationCriterions(cid, aid, campaignId, adGroupId) {
    const getCampaignLocationCriterionsPromise = getCampaignTargetsCriterions({
      type: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.LocationIntentCriterion')", cid, aid, campaignId,
    });
    const getAdGroupLocationCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.LocationIntentCriterion')", cid, aid, campaignId, adGroupId,
    });
    return Promise.all([getCampaignLocationCriterionsPromise, getAdGroupLocationCriterionsPromise]).then(([rawCampaignLocations, rawAdGroupLocations]) => {
      const {
        locations: campaignLocations,
      } = parseLocationTargets(rawCampaignLocations, 'campaign', campaignId);
      const {
        locations: adGroupLocations,
        intentId,
        intentOption,
      } = parseLocationTargets(rawAdGroupLocations, 'adgroup', adGroupId);
      const targetOption = campaignLocations.length ? locationTargetsOptionKeys.specific : locationTargetsOptionKeys.everywhere;
      this.patchAdgroup('location', {
        parentLevelSettings: {
          initLocations: campaignLocations,
          currentLocations: campaignLocations,
          targetOption,
        },
        currentLevelSettings: {
          initLocations: adGroupLocations,
          currentLocations: adGroupLocations,
          intentId,
          intentOption,
        },
        bidMode: true,
        useParentLevel: adGroupLocations.length === 0,
      });
    });
  }

  fetchCampaignAdGroupData(cid, aid, campaignId, adGroupId) {
    const getCampaignDataPromise = getCampaignData(cid, aid, campaignId);
    const getAdGroupDataPromise = getAdGroupData(cid, aid, campaignId, adGroupId);

    return Promise.all([getCampaignDataPromise, getAdGroupDataPromise]).then(([CampaignData, AdGroupData]) => {
      const {
        useParentLevel = true,
        currentLevelSettings: currentAdGroupSettings = { option: audienceAdsOptionKeys.Increase, value: 0 },
      } = AdGroupData.audienceAds;
      const {
        currentLevelSettings: currentCampaignSettings = { option: audienceAdsOptionKeys.Increase, value: 0 },
      } = CampaignData.audienceAds;
      const currentLevelSettings = useParentLevel ?
        currentCampaignSettings : currentAdGroupSettings;

      const audienceAds = {
        currentLevelSettings,
        parentLevelSettings: currentCampaignSettings,
        useParentLevel,
      };
      this.setState(prevState => ({
        campaign: { ...prevState.campaign, ...CampaignData },
        adgroup: { ...prevState.adgroup, ...AdGroupData, audienceAds },
      }));
    });
  }

  fetchCampaignData(cid, aid, campaignId) {
    const getCampaignDataPromise = getCampaignData(cid, aid, campaignId);

    return Promise.all([getCampaignDataPromise]).then(([CampaignData]) => {
      const {
        currentLevelSettings: currentCampaignSettings = { option: audienceAdsOptionKeys.Increase, value: 0 },
      } = CampaignData.audienceAds;
      this.setState(prevState => ({
        campaign: { ...prevState.campaign, ...CampaignData },
        adgroup: {
          ...prevState.adgroup,
          audienceAds: {
            currentLevelSettings: currentCampaignSettings,
            parentLevelSettings: currentCampaignSettings,
            useParentLevel: true,
          },
        },
      }));
    });
  }

  componentDidMount() {
    this.perfMarker.willFetchData();

    const {
      scenario,
    } = this.props;

    if (scenario === scenarios.creation) {
      const {
        cid,
        aid,
        campaignId,
      } = this.props.scope.values;

      Promise.all([
        renderAdGroupTargets(cid, aid, campaignId, undefined, this.patchAdgroup, this.state.adgroup, this),
        this.fetchCampaignData(cid, aid, campaignId),
        this.fetchCampaignLocationCriterions(cid, aid, campaignId),
        this.fetchCampaignDayTimeCriterions(cid, aid, campaignId),
      ]).finally(() => {
        this.perfMarker.willRender();
        this.setState(() => ({ isLoading: false, isDataFetched: true }));
      });

      this.handlePopState = () => {
        this.cancel();
      };

      window.addEventListener('popstate', this.handlePopState);
    } else if (scenario === scenarios.settings) {
      const {
        cid,
        aid,
        campaignId,
        adGroupId,
      } = this.props.scope.values;

      Promise.all([
        renderAdGroupTargets(cid, aid, campaignId, adGroupId, this.patchAdgroup, this.state.adgroup, this),
        this.fetchCampaignAdGroupData(cid, aid, campaignId, adGroupId),
        this.fetchLocationCriterions(cid, aid, campaignId, adGroupId),
        this.fetchDayTimeCriterions(cid, aid, campaignId, adGroupId),
      ]).finally(() => {
        this.perfMarker.willRender();
        this.setState(() => ({ isLoading: false, isDataFetched: true }));
      });
    }
  }

  componentDidUpdate() {
    if (this.state.isLoading === false && this.state.isDataFetched === true && this.perfMarker.isDone === false) {
      this.durationActivity.startSignal();
      this.perfMarker.done();
    }
  }

  componentWillUnmount() {
    this.activity.stop();
    if (this.state.adgroup && this.state.adgroup.Id) {
      invalidateCache('Model.AdGroup', [this.state.adgroup.Id]);
    }
    if (this.removeWarningInterval) {
      this.removeWarningInterval();
    }
    if (this.adScheduleView) {
      this.adScheduleView.undelegateEvents().off().remove();
    }
    if (this.isCreation) {
      window.removeEventListener('popstate', this.handlePopState);
    }
  }

  getAdScheduleValues = () => {
    const deletedDayTimeCb = (deletedDayTimeCriterions) => {
      _.each(deletedDayTimeCriterions, (criterion) => {
        criterion.Status = 'Deleted';
      });
    };

    return this.adScheduleView ? this.adScheduleView.getValues(deletedDayTimeCb) : [];
  };

  getUrlOptionsValues = () => {
    const urlOptionsData = this.urlOptionsView ? this.urlOptionsView.toObject() : {};

    if (_.isEmpty(urlOptionsData.TrackingUrlTemplate)) {
      urlOptionsData.TrackingUrlTemplate = null;
    }
    if (_.isEmpty(urlOptionsData.UrlCustomParameters)) {
      urlOptionsData.UrlCustomParameters = null;
    }
    return urlOptionsData;
  };

  getExclusionsValues = () => {
    const siteExclusionData = this.siteExclusionView ? this.siteExclusionView.getValues() : {};
    const ExcludedSites = siteExclusionData;
    return { ExcludedSites };
  };

  getValues = () => {
    const values = {
      ...this.state.adgroup,
      adScheduleData: this.getAdScheduleValues(),
      dateSettings: this.adScheduleView ? this.adScheduleView.getDateSettings() : {},
      netWorkOptions: this.adDistributionView ? this.adDistributionView.toObject() : {},
      urlOptions: this.getUrlOptionsValues(),
    };

    if (this.adScheduleView && this.adScheduleView.getAdScheduleUseSearcherTimeZone) {
      values.AdScheduleUseSearcherTimeZone = this.adScheduleView.getAdScheduleUseSearcherTimeZone();
    }

    return values;
  };

  initializeTheInstrumentation = () => {
    if (this.isCreation) {
      const scenario = instrumentation.hotelAdGroupCreation.create();

      this.activity = scenario.hotelAdGroupCreation.create();
      // duration activity, from user could edit & all successeed/completed
      this.durationActivity = scenario.duration.create();
      this.perfMarker = this.props.perfMarker.createChild('HotelAdGroupBaseCreation');
    } else {
      const scenario = instrumentation.hotelAdGroupSettings.create();

      this.activity = scenario.hotelAdGroupSettings.create();
      this.durationActivity = scenario.duration.create();
      this.perfMarker = this.props.perfMarker.createChild('HotelAdGroupBaseSettings');
    }
    // the component life time
    this.activity.start();
    send(this.activity, 'enter_page');

    this.perfMarker.willInit();
  };

  syncAdGroupLocationCriterionsPromise = (payload) => {
    const {
      cid,
      aid,
      campaignId,
      adGroupId,
    } = this.props.scope.values;
    if (adGroupId) {
      return this.syncAdGroupLocationCriterions(cid, aid, campaignId, adGroupId);
    } else if (payload && payload.entity && payload.entity.Id) {
      return this.syncAdGroupLocationCriterions(cid, aid, campaignId, payload.entity.Id);
    } else if (payload && payload.Id) {
      return this.syncAdGroupLocationCriterions(cid, aid, campaignId, payload.Id);
    }
    return Promise.resolve(true);
  };

  updateResponseData = (payload, resolve) => {
    if (!payload) {
      resolve(true);
      return;
    }
    // Fill back the data to the view;
    if (payload.entity && payload.entity.Id) { this.patchAdgroup('Id', payload.entity.Id); }
    const resourceName = 'AdGroupCriterions';

    if (this.adScheduleView) {
      this.adScheduleView.backFillItems(payload.entity ? payload : { entity: payload });
      if (payload.entity && payload.errors) {
        this.adScheduleView.handleErrors(payload);
      }
    }

    let resources = [];
    if (_.has(payload, 'entity') && _.has(payload.entity, resourceName)) {
      resources = payload.entity[resourceName];
    } else if (_.has(payload, resourceName)) {
      resources = payload[resourceName];
    }
    updateAllTargets(resources, this);

    if (payload && payload.errors) {
      this.removeWarningInterval = showWarning('adgroup', this.props.i18n, this.removeWarningInterval);
    }

    Promise.all([this.syncAdGroupLocationCriterionsPromise(payload), this.createDefaultHotelGroupAfterAdGroupCreation(payload)])
      .finally(() => resolve(true));
  };

  isExclusionsUpdated() {
    if (!this.siteExclusionView) {
      return false;
    }
    const siteExclusionsUpdated = this.siteExclusionView &&
      !_.isEqual(this.siteExclusionView.options.exclusions, this.siteExclusionView.getValues());
    return siteExclusionsUpdated;
  }

  saveExtensions() {
    const { campaignId, adGroupId } = this.props.scope.values;
    const data = {
      AdGroupId: adGroupId,
      CampaignId: campaignId,
      AdvancedSettings: {
        ...this.getExclusionsValues(),
      },
    };
    const that = this;
    return exclusionRepository.saveExtensions(data, 'adgroup')
      .then(() => {
        send(this.activity, 'adgroup_extensions_update_succeeded');
        that.siteExclusionView.clearApiErrors();
        that.patchErrMsg('baseExclusion', '');
        this.patchAdvancedSettinsApiErrors('baseExclusion', []);
      })
      .catch((response) => {
        send(this.activity, 'adgroup_extensions_update_failed');
        if (response.NegativeSitesResult || response.NegativeIPsResult) {
          const { NegativeSitesResult: siteErrors, NegativeIPsResult: ipErrors } = response;
          if (siteErrors || ipErrors) {
            if (that.siteExclusionView && siteErrors) {
              that.siteExclusionView.showErrors(siteErrors);
            }
            that.patchErrMsg('baseExclusion', globalErrorMsg);
            this.patchAdvancedSettinsApiErrors('baseExclusion', [{ siteErrors }]);
            scrollToErrors('adgroup');
          } else {
            that.siteExclusionView.clearApiErrors();
            that.patchErrMsg('baseExclusion', '');
            this.patchAdvancedSettinsApiErrors('baseExclusion', []);
          }
          // eslint-disable-next-line no-throw-literal
          throw 'exclusion error';
        }
      });
  }

  clearAllApiErrors() {
    clearSubViewApiErrors(this.subViews);
    this.setState(prev => ({
      targetsApiErrors: {},
      advancedSettinsApiErrors: { baseExclusions: prev.advancedSettinsApiErrors.baseExclusions },
    }));
  }

  save = () => {
    send(this.activity, 'save_clicked');
    // If something is wrong, you want show error message in the titlebar, you can patchErrMsg like below.
    // this.patchErrMsg('campaign', '*Required field'); // The two parameters are the key of Collapse.Panel, and the error message displayed.
    const isValid = this.validate();

    if (isValid) {
      const data = this.getValues();
      this.setState(() => ({ isLoading: true }));
      // TODO: which campaign (from props or api calls), should we use?
      const createOrUpdatePromise = this.createOrUpdateAdgroup(convertAdgroupStateToAdgroupJSONSchemaData(data, this.getCurrentCampaign(), this.state.initTargets));
      createOrUpdatePromise.finally(() => this.setState(() => ({ isLoading: false })));
    } else {
      scrollToErrors('adgroup');
    }
  };

  cancel = () => {
    send(this.activity, 'cancel_clicked');
    this.durationActivity.stopSignal('canceled');
    const {
      scope,
      siteMap,
    } = this.props;
    scope.save(getRoutePathById(siteMap, 'adgroups'));
  };

  patchAdgroup = (key, value) => {
    this.setState(prevState => ({
      adgroup: {
        ...prevState.adgroup,
        [key]: value,
      },
    }));
  };
  patchErrMsg = (key, value) => {
    this.setState(prevState => ({
      errMsg: {
        ...prevState.errMsg,
        [key]: value,
      },
    }));
  };
  patchTargetsApiErrMsg = (key, value) => {
    this.setState(prevState => ({
      targetsApiErrors: {
        ...prevState.targetsApiErrors,
        [key]: value,
      },
    }));
  };
  patchAdvancedSettinsApiErrors = (key, value) => {
    this.setState(prevState => ({
      advancedSettinsApiErrors: {
        ...prevState.advancedSettinsApiErrors,
        [key]: value,
      },
    }));
  };
  render() {
    const {
      classes,
      i18n,
      scenario,
      currentCampaign,
    } = this.props;

    const campaignName = currentCampaign && currentCampaign.Name;
    const campaignBidStrategy = this.state.campaign && this.state.campaign.bidStrategy;

    return (
      <div
        className={classnames(`hotel-adgroup-${scenario}-app`, classes.hotelAdGroupBase)}
        onFocus={() => { if (!_.isEmpty(this.state.adgroupApiErrors)) { _.delay(() => this.setState(() => ({ adgroupApiErrors: [] })), 200); } }}
      >
        <UiBlocker
          blocking={this.state.isLoading}
          loadingText={i18n.getString(_TL_('Loading...'))}
        >
          <div className={`hotel-adgroup-${scenario}-container hotel-adgroup-shared`} >
            {this.isCreation && <Title permissions={this.props.permissions} />}
            <Errors errors={!_.isEmpty(this.state.adgroupApiErrors) && this.state.adgroupApiErrors.map(x => x.message)} />
            <AdgroupBasic
              campaignName={campaignName}
              patchAdgroup={this.patchAdgroup}
              adgroup={this.state.adgroup}
              bidStrategy={campaignBidStrategy}
              scenario={scenario}
              permissions={this.props.permissions}
            />
            <AdvancedSettings
              campaign={this.state.campaign}
              adgroup={this.state.adgroup}
              patchAdgroup={this.patchAdgroup}
              setAdScheduleView={this.setAdScheduleView}
              getAdScheduleView={() => this.adScheduleView}
              setAdDistributionView={this.setAdDistributionView}
              getAdDistributionView={this.getAdDistributionView}
              setSiteExclusionView={this.setSiteExclusionView}
              setUrlOptionsView={this.setUrlOptionsView}
              scenario={scenario}
              errMsg={this.state.errMsg}
              patchErrMsg={this.patchErrMsg}
              getUrlOptionsValues={this.getUrlOptionsValues}
              getExclusionsValues={this.getExclusionsValues}
              advancedSettinsApiErrors={this.state.advancedSettinsApiErrors}
              isDataFetched={this.state.isDataFetched}
            />
            <AdgroupTargets
              patchAdgroup={this.patchAdgroup}
              adgroup={this.state.adgroup}
              campaign={this.state.campaign}
              errMsg={this.state.errMsg}
              patchErrMsg={this.patchErrMsg}
              scope={this.props.scope}
              targetsApiErrors={this.state.targetsApiErrors}
              patchTargetsApiErrMsg={this.patchTargetsApiErrMsg}
            />
            <div className="dashline" />
            <PrimaryButton text={i18n.getString(_TL_('Save'))} onClick={this.save} />
            <DefaultButton className="cancel-btn" text={i18n.getString(_TL_('Cancel'))} onClick={this.cancel} />
          </div>
        </UiBlocker>
      </div>
    );
  }
};

HotelAdGroupBase.propTypes = {
  currentCampaign: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
  scenario: PropTypes.string,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      cid: PropTypes.number.isRequired,
      aid: PropTypes.number.isRequired,
      campaignId: PropTypes.number,
      adGroupId: PropTypes.number,
    }).isRequired,
  }).isRequired,
  siteMap: PropTypes.shape([]).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  serverContext: PropTypes.shape({}).isRequired,
};

HotelAdGroupBase.defaultProps = {
  scenario: scenarios.creation,
};
